import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

const LoginPage = lazy(() => import('./components/LoginPage'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const AdminPage = lazy(() => import('./components/AdminPage'));

const ADMIN_PATH = '/gtadmin1324657980';

function useAdminRoute() {
  const [isAdminRoute, setIsAdminRoute] = useState(() => window.location.pathname === ADMIN_PATH);

  useEffect(() => {
    const onPop = () => setIsAdminRoute(window.location.pathname === ADMIN_PATH);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return isAdminRoute;
}

function AppLoading() {
  return (
    <div className="login-container">
      <div className="login-box" style={{ textAlign: 'center' }}>
        <LoadingSpinner />
        <p style={{ marginTop: 16, color: 'var(--text-secondary)' }}>加载中...</p>
      </div>
    </div>
  );
}

function App() {
  const { isAuthenticated } = useAuth();
  const isAdminRoute = useAdminRoute();

  if (isAdminRoute) {
    return (
      <div className="App">
        <Suspense fallback={<AppLoading />}>
          <AdminPage />
        </Suspense>
      </div>
    );
  }

  return (
    <div className="App">
      <Suspense fallback={<AppLoading />}>
        {isAuthenticated ? <Dashboard /> : <LoginPage />}
      </Suspense>
    </div>
  );
}

function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return (
    <Toaster position="top-right" toastOptions={{
      duration: 3000,
      style: {
        fontSize: '14px',
        borderRadius: '8px',
        background: resolvedTheme === 'dark' ? '#333' : '#fff',
        color: resolvedTheme === 'dark' ? '#fff' : '#333',
        border: resolvedTheme === 'dark' ? '1px solid #555' : '1px solid #eee',
      },
    }} />
  );
}

function AppWithAuth() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <App />
        <ThemedToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default AppWithAuth;
